/**
 * Common styles for announcement components
 */
// Color constants
export const COLORS = {
  PRIMARY: '#486791',
  PRIMARY_HOVER: '#3d5a7a',
  SECONDARY: '#F1AC2F',
  SECONDARY_HOVER: '#e09a1f',
  TEXT_PRIMARY: '#374151',
  TEXT_SECONDARY: '#6b7280',
  TEXT_MUTED: '#9ca3af',
  BORDER: '#e5e7eb',
  BORDER_HOVER: '#d1d5db',
  BACKGROUND: '#f3f4f6',
  WHITE: '#ffffff',
  SUCCESS: '#3b82f6',
  SUCCESS_HOVER: '#2563eb'
};
// Common button styles
export const BUTTON_STYLES = {
  PRIMARY: {
    backgroundColor: COLORS.PRIMARY,
    '&:hover': { backgroundColor: COLORS.PRIMARY_HOVER }
  },
  SECONDARY: {
    borderColor: COLORS.SECONDARY,
    color: COLORS.SECONDARY,
    backgroundColor: COLORS.WHITE,
    '&:hover': { 
      backgroundColor: COLORS.SECONDARY,
      color: COLORS.WHITE,
      borderColor: COLORS.SECONDARY
    }
  },
  TEXT: {
    color: COLORS.SUCCESS,
    textDecoration: 'underline',
    '&:hover': { 
      color: COLORS.SUCCESS_HOVER,
      backgroundColor: 'transparent'
    }
  }
};
// Common input styles
export const INPUT_STYLES = {
  OUTLINED: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.BORDER,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.BORDER_HOVER,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.PRIMARY,
    },
  },
  LABEL: {
    fontSize: '0.875rem',
    '&.Mui-focused': { color: COLORS.PRIMARY },
    '&.MuiFormLabel-filled': { color: COLORS.PRIMARY }
  }
};
// Card styles
export const CARD_STYLES = {
  BASE: {
    backgroundColor: COLORS.WHITE,
    borderRadius: 2,
    border: `1px solid ${COLORS.BORDER}`,
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    '&:hover': {
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      transform: 'translateY(-1px)',
      transition: 'all 0.2s ease-in-out'
    }
  }
};
// Typography styles
export const TYPOGRAPHY_STYLES = {
  TITLE: {
    fontWeight: 600,
    color: COLORS.TEXT_PRIMARY,
    fontSize: '1rem'
  },
  CONTENT: {
    color: COLORS.TEXT_SECONDARY,
    lineHeight: 1.5,
    fontSize: '0.875rem'
  },
  MUTED: {
    color: COLORS.TEXT_MUTED,
    fontSize: '0.75rem',
    fontWeight: 500
  }
};
// Icon button styles
export const ICON_BUTTON_STYLES = {
  BASE: {
    color: COLORS.TEXT_SECONDARY,
    '&:hover': {
      backgroundColor: 'rgba(107, 114, 128, 0.1)',
      color: COLORS.TEXT_PRIMARY
    }
  }
};
// Modal styles
export const MODAL_STYLES = {
  DIALOG: {
    borderRadius: 2,
    minHeight: '40vh',
    maxHeight: '70vh',
    mt: 2
  },
  BACKDROP: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backdropFilter: 'blur(8px)',
    WebkitBackdropFilter: 'blur(8px)'
  }
};
// Grid styles
export const GRID_STYLES = {
  CONTAINER: {
    display: 'grid', 
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', 
    gap: 2 
  }
};
// Animation constants
export const ANIMATIONS = {
  TRANSITION: 'all 0.2s ease-in-out',
  HOVER_TRANSFORM: 'translateY(-1px)'
};
// Spacing constants
export const SPACING = {
  XS: 0.5,
  SM: 1,
  MD: 1.5,
  LG: 2,
  XL: 3
}; 